import { useState, useEffect } from 'react';
import { Modal, Typography, TimePicker, Button } from 'antd';
import { observer } from 'mobx-react';
import moment from 'moment';
import { useMst } from '@models/Root';
import { useToasts } from 'react-toast-notifications';

const { Text } = Typography;

export const TimelineItemConfigModal = observer(() => {
  const {
    timelineItemConfigVisible,
    setTimelineItemConfigVisible,
    selectedTimelineItem,
    updateSelectedTimelineItemTime,
    setTimelineLoading,
    removeSelectedTimelineItem,
  } = useMst().timetable;
  const [slotDuration, setSlotDuration] = useState({ startTime: moment(), endTime: moment() });
  const { addToast } = useToasts();

  useEffect(() => {
    if (selectedTimelineItem) {
      setSlotDuration({ startTime: selectedTimelineItem.startTime, endTime: selectedTimelineItem.endTime });
    }
  }, [selectedTimelineItem]);

  const updateSlotTime = () => {
    if (selectedTimelineItem) {
      updateSelectedTimelineItemTime({
        startTime: slotDuration.startTime,
        endTime: slotDuration.endTime,
        groupID: selectedTimelineItem.groupID,
      });

      setTimeout(() => {
        setTimelineLoading(false);
      }, 1000);
    }

    setTimelineItemConfigVisible(false);
  };

  return selectedTimelineItem ? (
    <Modal
      title="Timetable item configuration"
      visible={timelineItemConfigVisible}
      onCancel={() => setTimelineItemConfigVisible(false)}
      footer={[
        <Button
          danger
          onClick={() => {
            removeSelectedTimelineItem(addToast);
          }}
        >
          Delete
        </Button>,
        <Button
          type="primary"
          onClick={() => {
            updateSlotTime();
          }}
        >
          Save
        </Button>,
      ]}
    >
      <div className="timetable-item-configuration-modal">
        <div>
          <div style={{ marginBottom: 5 }}>
            <Text>Start time</Text>
          </div>
          <TimePicker
            value={moment(slotDuration.startTime)}
            format="HH:mm"
            onSelect={(time) => setSlotDuration({ startTime: time, endTime: slotDuration.endTime })}
          />
        </div>

        <div>
          <div style={{ marginBottom: 5 }}>
            <Text>End time</Text>
          </div>
          <TimePicker
            value={moment(slotDuration.endTime)}
            format="HH:mm"
            onSelect={(time) => setSlotDuration({ startTime: slotDuration.startTime, endTime: time })}
          />
        </div>
      </div>
    </Modal>
  ) : (
    <div />
  );
});
